 export const templateShare = () => {
   return `
      <html lang="es">
        <head>
          <meta charset="UTF-8">
          <title>Campaña de Referidos - Casaideal</title>
          <style>
            body {
              font-family: 'Arial', sans-serif;
              background-color: #f4f4f4;
              padding: 20px;
              margin: 0;
            }
            .container {
              max-width: 600px;
              background-color: #ffffff;
              margin: auto;
              padding: 30px;
              border-radius: 8px;
              box-shadow: 0 4px 10px rgba(0,0,0,0.1);
            }
            h2 {
              color: #2c3e50;
            }
            p {
              color: #555555;
              line-height: 1.5;
            }
            .button {
              display: inline-block;
              margin-top: 20px;
              padding: 12px 20px;
              background-color: #007BFF;
              color: white;
              text-decoration: none;
              border-radius: 6px;
              font-weight: bold;
            }
            .footer {
              margin-top: 30px;
              font-size: 12px;
              color: #999;
            }
          </style>
        </head>
        <body>
          <div class="container">
            <h2>¡Invita y gana con Casaideal!</h2>
            <p>
              El beneficio <strong>“Campaña de Referidos”</strong> está dirigido a propietarios que deseen referir a un familiar o amigo interesado en adquirir un departamento en alguno de nuestros proyectos.
            </p>
            <p>
              Al participar, podrás recibir una <strong>Giftcard de hasta S/2,000</strong> como agradecimiento. Este beneficio está sujeto a las condiciones específicas de cada proyecto.
            </p>
            <p>
              ¡Es fácil! Solo haz clic en el siguiente enlace y completa la información de la persona que deseas referir:
            </p>
            <a class="button" style="color:white;background-color:red" href="https://www.casaideal.com.pe/referidos">Referir ahora</a>

            <p class="footer">
              *Aplican términos y condiciones. Para más detalles, visita nuestro sitio web o comunícate con tu asesor.
            </p>
          </div>
        </body>
        </html>
   `;
 }